import { Inject, Injector } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ButtonOptions } from '../eva-button/eva-button.component';
import { AbstractComponent } from '../abstract.component';
import { PictureData } from '../picture/picture.component';
import { MediaPictureService } from 'projects/common/services/media-picture.service';
import { Module } from 'projects/common/model/ModuleModel';

interface SubscriptionActivationModel {
  icon_picture: PictureData;
  available: boolean;
}

@Component({
  selector: 'subscription-activation',
  template: `
    <div *ngIf="module.data.available" class="subscription-activation-container">
      <div class="icon">
        <media-picture
                 [mediaKey]="iconMediaKey"
                 [imageHeight]="30"
                 [imageWidth]="30"
                 [previewMode]="'image'"
                 [resizeType]="'FIT'"
                 product="nymeria-gui"
                 [flow]="flow">
        </media-picture>
      </div>
      <div class="subscription-activation-bubble subscription-activation-bubble-bottom-left">
        <div class="bubble-text">
          <p class="subscription-text">{{'subscription.activation.bubbleText' | translate}}</p>
        </div>
        <div class="bubble-button">
          <eva-button (clickEvent)="activateWebNotifications()"  [options]="buttonOptions"
            moduleId="SubscriptionActivationModule"
            [moduleIndex]="module.row_number" [moduleId]="getModuleId()" [uniqueId]="module.unique_id"></eva-button>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./subscription-activation.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SubscriptionActivationComponent extends AbstractComponent implements OnInit {

  getModuleId(): string {
    return "SubscriptionActivationModule";
  }

  @Input() override module: Module<SubscriptionActivationModel>;
  window: any;
  iconMediaKey: string;

  buttonOptions: ButtonOptions = {
    type: '-primary',
    link_text: ''
  };

  constructor(injector: Injector, @Inject(DOCUMENT) private document: Document,
    private translateService: TranslateService,
    public mediaPictureService: MediaPictureService) {
    super(injector);
    this.window = this.document.defaultView;
  }

  ngOnInit(): void {
    this.buttonOptions.link_text = this.translateService.instant('subscription.activation.activateButton');
    this.iconMediaKey = this.screenType === "MOBILE" && this.module.data.icon_picture?.src_mobile
      ? this.module.data.icon_picture.src_mobile
      : this.module.data.icon_picture?.src
  }

  activateWebNotifications(): void {
    if (this.window.DespegarWebNotifications) {
      this.window.DespegarWebNotifications.askPermissionAndSubscribe()
        .catch(err => {
          if (this.window.newrelic && this.window.newrelic.noticeError) {
            this.window.newrelic.noticeError(`Error trying to activate web notifications: ${err.toString()}`);
          }
        });
    }
  }

}
